import React, { useRef, useContext } from 'react';
import { Modal, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

import { AntInput } from '../AntField';
import FormButton from '../FormButton';
import { InvContext } from '../../context/InventoryContext/InventoryContext';
import { Utils } from '../../context/UtilsContext';
import Confirm from '../Confirm';

const validateForm = Yup.object().shape({
	label: Yup.string()
		.max(50)
		.min(1)
		.required()
		.matches(/^[a-zA-Z0-9-_]+$/, {
			message: 'Only alphabets, numbers, underscore and dash are allowed.',
			excludeEmptyString: true,
		})
		.label('Location label'),
	showOnMap: Yup.boolean(),
});

const LocationModal = props => {
	const { closeModal, data, visible } = props;
	const initialValue = useRef();
	const { addLocation, updateLocation } = useContext(InvContext);
	const { setLoading } = useContext(Utils);

	if (!Object.prototype.hasOwnProperty.call(data, 'id')) {
		initialValue.current = {
			label: '',
			showOnMap: true,
		};
	} else initialValue.current = { ...data, showOnMap: !!data.showOnMap };

	return (
		<Modal
			visible={visible}
			style={{ top: 20 }}
			onCancel={closeModal}
			title="Location details"
			footer={null}
			width={500}
			destroyOnClose
		>
			<Formik
				onSubmit={(values, { setSubmitting, resetForm }) => {
					if (Object.prototype.hasOwnProperty.call(values, 'id'))
						Confirm(updateLocation, setSubmitting, values, setLoading, closeModal);
					else Confirm(addLocation, setSubmitting, values, setLoading, resetForm);
				}}
				validationSchema={validateForm}
				initialValues={initialValue.current}
			>
				{({ values, handleSubmit, handleReset, isSubmitting, setFieldValue }) => (
					<Form>
						<Field component={AntInput} name="label" value={values.label} label="Location Label" />
						<Checkbox
							value={values.showOnMap}
							checked={values.showOnMap}
							defaultChecked={values.showOnMap}
							style={{ margin: '10px 0' }}
							onChange={e => setFieldValue('showOnMap', e.target.checked)}
						>
							Show on location map
						</Checkbox>
						<FormButton
							handleReset={handleReset}
							handleSubmit={handleSubmit}
							isSubmitting={isSubmitting}
						/>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

LocationModal.propTypes = {
	closeModal: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	data: PropTypes.object.isRequired,
};

export default LocationModal;
